import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeliciousComponent } from './simple-icons-delicious.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeliciousComponent ],
    exports:      [ SimpleIconsDeliciousComponent ],
    bootstrap:    []
})
export class SimpleIconsDeliciousModule {}
